export const Footer =()=> {
    return(
        <section className="footer">
             <p>Designed and Built by Joy LoRuth, <b>(C) 2024</b> </p>
        </section>
       
    )
}